import React from "react";
import { Card } from "@/components/ui/card";

const gloriaFoodBlock = (position) => (
  <div
    className="my-8 flex justify-center"
    data-testid={`menu-gloriafood-${position}`}
  >
    <span
      className="glf-button inline-flex items-center justify-center rounded-full bg-[#7ED956] px-6 py-2.5 text-sm font-semibold text-white hover:bg-[#6ac445]"
      data-glf-cuid="9355d15b-6f1a-4b1c-ad74-8f75ce295108"
      data-glf-ruid="111089d3-19e8-419f-bf42-1843cf64f484"
    >
      Bestel online
    </span>
    <script src="https://www.fbgcdn.com/embedder/js/ewm2.js" defer async></script>
  </div>
);
const featuredDishes = [
  {
    id: "mesa-cubana",
    name: "A lo Cubano – Mesa Cubana",
    price: "€55,00",
    description: "Sharing menu voor 2 personen, een selectie van Cubaanse specialiteiten",
  },
  {
    id: "ropa-vieja",
    name: "Ropa Vieja (nationaal gerecht)",
    price: "€25,00",
    description: "Gestoofd rundvlees volgens traditioneel Cubaans recept",
  },
  {
    id: "vaca-frita",
    name: "Vaca Frita",
    price: "€23,00",
    description: "Krokant rundvlees met ui en limoen",
  },
  {
    id: "pastelon",
    name: "Pastelón",
    price: "€19,00",
    description: "Bakbanaan-ovenschotel, ook vegan mogelijk",
  },
];

const menuSections = [
    {
      id: "cubaanse-gerechten",
      title: "A Lo Cubano",
      items: [
      {
        name: "A lo Cubano – Mesa Cubana",
        price: "€55,00",
        description: "Sharing menu voor 2 personen",
      },
      {
        name: "Plato frito",
        price: "€17,00",
        description: "Gefrituurde hapjes",
      },
      {
        name: "Bitterballen",
        price: "€9,00",
        description: "Portie bitterballen",
      },
      {
        name: "Ropa vieja",
        price: "€25,00",
        description: "Gestoofd rundvlees (nationaal gerecht)",
      },
      {
        name: "Vaca frita",
        price: "€23,00",
        description: "Krokant rundvlees met ui en limoen",
      },
      {
        name: "Nacho ropa vieja (M)",
        price: "€14,00",
        description: "Nacho’s met ropa vieja",
      },
      {
        name: "Nacho ropa vieja (L)",
        price: "€19,00",
        description: "Grote portie nacho’s met ropa vieja",
      },
      {
        name: "Nacho Aroma",
        price: "€17,00",
        description: "Bakbanaan in plaats van nacho’s",
      },
      {
        name: "Pastelón",
        price: "€19,00",
        description: "Bakbanaan-ovenschotel (ook vegan mogelijk)",
      },
      {
        name: "Maandmenu Cubano",
        price: "€28,00",
      },
    ],
  },
  {
    id: "broodjes",
    title: "Broodjes",
    items: [
      {
        name: "Cuban sandwich",
        price: "€9,00",
        description: "Gegrilde sandwich met ham, kaas, geroosterd varkensvlees, augurken en mosterd",
      },
      {
        name: "Ropa vieja",
        price: "€8,00",
        description: "Broodje met gestoofd Cubaanse rundvlees",
      },
      {
        name: "Ham & kaas",
        price: "€4,10",
        description: "Klassiek broodje met ham en kaas",
      },
      {
        name: "Tonijn",
        price: "€4,10",
        description: "Broodje met tonijnsalade",
      },
      {
        name: "Mexicano",
        price: "€4,50",
        description: "Broodje met pittige mexicano snack en saus",
      },
      {
        name: "Krabsla",
        price: "€4,50",
        description: "Broodje met krabsalade",
      },
      {
        name: "Brie",
        price: "€4,20",
        description: "Broodje met zachte brie",
      },
      {
        name: "Studentenmenu",
        price: "€7,00",
        description: "Broodje + drankje + gratis fruit",
        highlight: true,
      },
    ],
  },
  {
    id: "iets-dichter-bij-huis",
    title: "Iets dichter bij huis",
    items: [
      {
        name: "Spaghetti",
        price: "€15,00",
      },
      {
        name: "Kinderspaghetti",
        price: "€11,00",
      },
      {
        name: "Stoofvlees",
        price: "€20,00",
      },
      {
        name: "Soep van de dag",
        price: "€6,50",
      },
      {
        name: "Croque Monsieur",
        price: "€8,50",
      },
      {
        name: "Croque Madame",
        price: "€9,50",
      },
      {
        name: "Omelet (spek of natuur)",
        price: "€12,00",
        description: "Keuze tussen spek of natuur",
      },
    ],
  },
  {
    id: "cocktails",
    title: "Cocktails",
    items: [
      { name: "Mojito", price: "€10,00" },
      { name: "Mojito Passion", price: "€11,00" },
      { name: "Cuba Libre", price: "€9,00" },
      { name: "Canchanchara", price: "€9,00" },
      { name: "Aroma Cubana", price: "€13,00" },
      { name: "Coco Loco", price: "€13,00" },
      { name: "Gin Fizz", price: "€9,50" },
      { name: "Lazy Red Cheeks", price: "€12,00" },
      { name: "Vampisol", price: "€9,50" },
    ],
  },
  {
    id: "fris-smoothies",
    title: "Fris & Smoothies",
    items: [
      { name: "Water plat / bruis", price: "€2,70" },
      { name: "Verse limonade", price: "€4,50" },
      { name: "Cola (zero)", price: "€3,00" },
      { name: "Fanta", price: "€3,00" },
      { name: "Ice Tea", price: "€3,00" },
      { name: "Agrum", price: "€3,00" },
      { name: "Tonic", price: "€3,00" },
      { name: "Malteada", price: "€4,00" },
      { name: "Mango smoothie", price: "€6,00" },
      { name: "Groenten smoothie", price: "€5,00" },
      { name: "Kokosnoot smoothie", price: "€6,50" },
    ],
  },
  {
    id: "bieren",
    title: "Bieren",
    items: [
      { name: "Stella", price: "€3,10" },
      { name: "Carlsberg", price: "€3,20" },
      { name: "Carlsberg 0,0%", price: "€3,00" },
      { name: "Orval", price: "€5,00" },
      { name: "Karmeliet", price: "€4,40" },
      { name: "Kriek", price: "€3,80" },
      { name: "Streekbier", price: "€3,90" },
    ],
  },
  {
    id: "sterk-likeur",
    title: "Sterk & Likeur",
    items: [
      { name: "Havana 7 jaar", price: "€8,00" },
      { name: "Havana Especial", price: "€9,00" },
      { name: "Mezcal", price: "€9,00" },
      { name: "Gin", price: "€7,00" },
      { name: "Hennessy", price: "€9,00" },
      { name: "Vodka vanille", price: "€8,00" },
      {
        name: "Ponche de pistacho",
        price: "€7,50",
        description: "Cubaanse pistache-likeur",
      },
    ],
  },
  {
    id: "wijn-bubbels",
    title: "Wijn & Bubbels",
    items: [
      { name: "Rood Malbec", price: "€6,20" },
      { name: "Wit Chardonnay", price: "€6,00" },
      { name: "Cava", price: "€7,00" },
      { name: "Aperitief van het huis", price: "€8,00" },
    ],
  },
  {
    id: "warme-dranken",
    title: "Warme dranken",
    items: [
      { name: "Cubaanse koffie", price: "€4,50" },
      {
        name: "Café bombón",
        price: "€4,20",
        description: "Espresso met gecondenseerde melk",
      },
      { name: "Koffie", price: "€3,00" },
      { name: "Espresso", price: "€2,70" },
      { name: "Latte", price: "€4,80" },
      { name: "Latte Caramel", price: "€5,00" },
      { name: "Iced koffie", price: "€6,00" },
      { name: "Thee", price: "€3,00" },
    ],
  },
];

const MenuPage = () => {
  return (
    <main
      className="min-h-screen bg-[#F5F1E8] px-4 pb-20 pt-24 text-[#3E2723] md:px-6"
      data-testid="menu-page"
    >
      <header className="mx-auto max-w-5xl text-center">
        <p className="text-xs font-medium uppercase tracking-[0.18em] text-[#7ED956]">
          Menu
        </p>
        <h1 className="mt-3 font-['Fraunces',_serif] text-3xl md:text-4xl">
          Volledige kaart van Aroma Cubana
        </h1>
        <p className="mt-3 text-sm text-[#3E2723]/80 md:text-base">
          Ontdek al onze Cubaanse gerechten, broodjes, desserts en dranken. Online bestellen doe je makkelijk via GloriaFood.
        </p>
      </header>

      {gloriaFoodBlock("top")}

      <section
        className="mx-auto mt-8 max-w-5xl rounded-2xl border border-[#3E2723]/10 bg-white/80 p-6 shadow-sm backdrop-blur-sm"
        data-testid="menu-aanraders-section"
      >
        <div className="flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
          <div className="text-left">
            <p className="text-xs font-medium uppercase tracking-[0.18em] text-[#7ED956]">
              Aanraders van Ada &amp; Maya
            </p>
            <h2 className="mt-2 font-['Fraunces',_serif] text-2xl text-[#3E2723]">
              Onze favoriete Cubaanse klassiekers
            </h2>
            <p className="mt-2 text-sm text-[#3E2723]/80 md:text-base">
              Deze gerechten vertellen het verhaal van onze keuken – huisgemaakt, warm
              en boordevol smaak.
            </p>
          </div>
          <div className="mt-3 md:mt-0">
            <span
              className="glf-button inline-flex items-center justify-center rounded-full bg-[#7ED956] px-5 py-2.5 text-sm font-semibold text-white hover:bg-[#6ac445]"
              data-glf-cuid="9355d15b-6f1a-4b1c-ad74-8f75ce295108"
              data-glf-ruid="111089d3-19e8-419f-bf42-1843cf64f484"
              data-testid="menu-aanraders-bestel-button"
            >
              Bestel online
            </span>
            <script src="https://www.fbgcdn.com/embedder/js/ewm2.js" defer async></script>
          </div>
        </div>

        <div className="mt-5 grid gap-4 md:grid-cols-2 xl:grid-cols-4">
          {featuredDishes.map((dish) => (
            <Card
              key={dish.id}
              className="flex h-full flex-col justify-between rounded-2xl border border-[#3E2723]/10 bg-[#F5F1E8]/60 p-4 shadow-sm"
              data-testid={`menu-aanrader-${dish.id}`}
            >
              <div>
                <div className="flex items-baseline justify-between gap-2">
                  <h3 className="text-sm font-semibold text-[#3E2723] md:text-base">
                    {dish.name}
                  </h3>
                  <span className="text-sm font-semibold text-[#7ED956]">
                    {dish.price}
                  </span>
                </div>
                <p className="mt-2 text-xs text-[#3E2723]/80 md:text-sm">
                  {dish.description}
                </p>
              </div>
            </Card>
          ))}
        </div>
      </section>


      <div className="mx-auto mt-6 grid max-w-5xl gap-6 md:grid-cols-2">
        {menuSections.map((section) => (
          <Card
            key={section.id}
            className="flex flex-col gap-3 rounded-2xl border border-[#3E2723]/10 bg-white/70 p-5 shadow-sm backdrop-blur-sm"
            data-testid={`menu-section-${section.id}`}
          >
            <h2 className="font-['Fraunces',_serif] text-xl">
              {section.title}
            </h2>
            <ul className="mt-2 space-y-3 text-sm md:text-base">
              {section.items.map((item) => (
                <li
                  key={item.name}
                  className={`border-b border-dashed border-[#3E2723]/10 pb-2 last:border-b-0 ${
                    item.unavailable ? "opacity-60" : ""
                  }`}
                  data-testid={`menu-item-${section.id}-${item.name.replace(/[^a-z0-9]/gi, "-").toLowerCase()}`}
                >
                  <div className="flex items-baseline justify-between gap-3">
                    <span className="font-medium">
                      {item.name}
                    </span>
                    {item.price && (
                      <span className="text-sm font-semibold text-[#7ED956]">
                        {item.price}
                      </span>
                    )}
                  </div>
                  {item.description && (
                    <p className="mt-1 text-xs italic text-[#3E2723]/80 md:text-sm">
                      {item.description}
                    </p>
                  )}
                  {item.unavailable && (
                    <p className="mt-1 text-[11px] font-medium uppercase tracking-wide text-[#3E2723]/70">
                      Tijdelijk niet beschikbaar
                    </p>
                  )}
                </li>
              ))}
            </ul>
          </Card>
        ))}
      </div>

      <section className="mx-auto mt-6 max-w-3xl text-center text-sm text-[#3E2723]/80 md:text-base">
        <p>
          Gerechten kunnen wijzigen naargelang het seizoen en de beschikbaarheid.
          Heb je vragen over allergenen of speciale wensen, spreek ons gerust aan
          in het eetcafé.
        </p>
      </section>

      {gloriaFoodBlock("bottom")}
    </main>
  );
};

export default MenuPage;
